var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommunity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 263,
    height: 185,
    viewBox: "0 0 263 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12771_213521)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 263,
    height: 185,
    fill: "#111213"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.2009,
    y: 108.201,
    width: 52.5982,
    height: 51.5982,
    rx: 7.79909,
    fill: "url(#paint0_linear_12771_213521)",
    fillOpacity: 0.8,
    stroke: "url(#paint1_linear_12771_213521)",
    strokeWidth: 0.401822
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.2009,
    y: 79.2009,
    width: 52.5982,
    height: 80.5982,
    rx: 7.79909,
    fill: "url(#paint2_linear_12771_213521)",
    fillOpacity: 0.8,
    stroke: "url(#paint3_linear_12771_213521)",
    strokeWidth: 0.401822
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.201,
    y: 54.2009,
    width: 52.5982,
    height: 105.598,
    rx: 7.79909,
    fill: "url(#paint4_linear_12771_213521)",
    fillOpacity: 0.8,
    stroke: "url(#paint5_linear_12771_213521)",
    strokeWidth: 0.401822
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bd_12771_213521)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 108,
    width: 53,
    height: 52,
    rx: 8,
    fill: "url(#paint6_linear_12771_213521)",
    fillOpacity: 0.8,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.201,
    y: 108.201,
    width: 52.5982,
    height: 51.5982,
    rx: 7.79909,
    stroke: "url(#paint7_linear_12771_213521)",
    strokeWidth: 0.401822,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_12771_213521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.1161 97.1169H27.267V95.9848C25.7539 95.8324 25.0136 94.7873 24.8939 93.8294L25.928 93.5028C25.9934 94.1995 26.407 94.8744 27.267 95.0268V92.7517L26.9948 92.6973C25.8845 92.4687 25.1878 91.7829 25.1878 90.7161C25.1878 89.6819 26.0478 88.8002 27.267 88.6478V87.5048H28.1161V88.6587C29.455 88.8329 29.9775 89.7255 30.1517 90.4331L29.172 90.7923C29.1067 90.3786 28.7801 89.8126 28.1161 89.6275V91.8591L28.2794 91.8917C29.4877 92.1312 30.217 92.9368 30.217 93.9165C30.217 94.8853 29.4986 95.8215 28.1161 95.9848V97.1169ZM29.1502 93.9709C29.1502 93.5137 28.8236 93.0892 28.1161 92.9259V95.0268C28.8236 94.8962 29.1502 94.4717 29.1502 93.9709ZM26.2655 90.6725C26.2655 91.1297 26.5268 91.5216 27.267 91.6631V89.5949C26.6356 89.7146 26.2655 90.1391 26.2655 90.6725ZM32.3175 92.3163C32.3175 93.394 32.5135 94.156 32.938 94.6023C33.2102 94.8853 33.5585 95.0595 34.0592 95.0595C34.56 95.0595 34.9083 94.8853 35.1805 94.6023C35.605 94.156 35.801 93.394 35.801 92.3163C35.801 91.2386 35.605 90.4766 35.1805 90.0303C34.9083 89.7473 34.56 89.5731 34.0592 89.5731C33.5585 89.5731 33.2102 89.7473 32.938 90.0303C32.5135 90.4766 32.3175 91.2386 32.3175 92.3163ZM31.2616 92.3163C31.2616 91.3475 31.4249 90.4548 31.893 89.7581C32.3502 89.0723 33.0578 88.626 34.0592 88.626C35.0607 88.626 35.7683 89.0723 36.2255 89.7581C36.6936 90.4548 36.8569 91.3475 36.8569 92.3163C36.8569 93.2851 36.6936 94.1777 36.2255 94.8744C35.7683 95.5602 35.0607 96.0065 34.0592 96.0065C33.0578 96.0065 32.3502 95.5602 31.893 94.8744C31.4249 94.1777 31.2616 93.2851 31.2616 92.3163ZM40.8438 93.1654H37.8938V92.2727H40.8438V93.1654ZM45.1037 97.1169H44.2546V95.9848C42.7415 95.8324 42.0013 94.7873 41.8816 93.8294L42.9157 93.5028C42.981 94.1995 43.3947 94.8744 44.2546 95.0268V92.7517L43.9825 92.6973C42.8722 92.4687 42.1755 91.7829 42.1755 90.7161C42.1755 89.6819 43.0354 88.8002 44.2546 88.6478V87.5048H45.1037V88.6587C46.4427 88.8329 46.9652 89.7255 47.1394 90.4331L46.1596 90.7923C46.0943 90.3786 45.7678 89.8126 45.1037 89.6275V91.8591L45.267 91.8917C46.4753 92.1312 47.2047 92.9368 47.2047 93.9165C47.2047 94.8853 46.4862 95.8215 45.1037 95.9848V97.1169ZM46.1379 93.9709C46.1379 93.5137 45.8113 93.0892 45.1037 92.9259V95.0268C45.8113 94.8962 46.1379 94.4717 46.1379 93.9709ZM43.2532 90.6725C43.2532 91.1297 43.5144 91.5216 44.2546 91.6631V89.5949C43.6233 89.7146 43.2532 90.1391 43.2532 90.6725ZM50.8375 95.8433H49.7925V90.8685H48.0834V90.1174C49.0632 90.0956 49.7381 89.5513 49.9014 88.7893H50.8375V95.8433ZM60.9671 95.8433H59.9112V89.8343L57.2769 95.8433H56.2971L53.6846 89.8343V95.8433H52.6287V88.1253H54.0765L56.7979 94.4063L59.5411 88.1253H60.9671V95.8433Z",
    fill: "#9097A3"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_12771_213521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.287 70.8098H74.4379V69.6776C72.9248 69.5252 72.1845 68.4802 72.0648 67.5223L73.0989 67.1957C73.1643 67.8924 73.5779 68.5673 74.4379 68.7197V66.4446L74.1657 66.3902C73.0554 66.1616 72.3587 65.4758 72.3587 64.409C72.3587 63.3748 73.2187 62.4931 74.4379 62.3407V61.1977H75.287V62.3516C76.6259 62.5257 77.1484 63.4184 77.3226 64.1259L76.3429 64.4852C76.2776 64.0715 75.951 63.5054 75.287 63.3204V65.552L75.4503 65.5846C76.6586 65.8241 77.3879 66.6296 77.3879 67.6094C77.3879 68.5782 76.6695 69.5144 75.287 69.6776V70.8098ZM76.3211 67.6638C76.3211 67.2066 75.9945 66.782 75.287 66.6188V68.7197C75.9945 68.5891 76.3211 68.1645 76.3211 67.6638ZM73.4364 64.3654C73.4364 64.8226 73.6977 65.2145 74.4379 65.356V63.2877C73.8065 63.4075 73.4364 63.832 73.4364 64.3654ZM81.0208 69.5361H79.9757V64.5614H78.2667V63.8102C79.2464 63.7885 79.9213 63.2442 80.0846 62.4822H81.0208V69.5361ZM91.1503 69.5361H90.0944V63.5272L87.4601 69.5361H86.4804L83.8678 63.5272V69.5361H82.8119V61.8182H84.2597L86.9811 68.0992L89.7243 61.8182H91.1503V69.5361ZM95.5731 66.8582H92.6231V65.9656H95.5731V66.8582ZM99.833 70.8098H98.9839V69.6776C97.4708 69.5252 96.7305 68.4802 96.6108 67.5223L97.6449 67.1957C97.7103 67.8924 98.1239 68.5673 98.9839 68.7197V66.4446L98.7117 66.3902C97.6014 66.1616 96.9047 65.4758 96.9047 64.409C96.9047 63.3748 97.7647 62.4931 98.9839 62.3407V61.1977H99.833V62.3516C101.172 62.5257 101.694 63.4184 101.869 64.1259L100.889 64.4852C100.824 64.0715 100.497 63.5054 99.833 63.3204V65.552L99.9963 65.5846C101.205 65.8241 101.934 66.6296 101.934 67.6094C101.934 68.5782 101.215 69.5144 99.833 69.6776V70.8098ZM100.867 67.6638C100.867 67.2066 100.541 66.782 99.833 66.6188V68.7197C100.541 68.5891 100.867 68.1645 100.867 67.6638ZM97.9824 64.3654C97.9824 64.8226 98.2437 65.2145 98.9839 65.356V63.2877C98.3525 63.4075 97.9824 63.832 97.9824 64.3654ZM102.815 67.6202L103.838 67.3154C103.904 68.1863 104.546 68.7741 105.428 68.7741C106.266 68.7741 106.941 68.219 106.941 67.3481C106.941 66.3793 106.233 65.8894 105.417 65.8894C104.916 65.8894 104.437 66.0854 104.132 66.401C103.762 66.2595 103.447 66.118 103.087 65.9874L104.002 62.4822H107.725V63.4619H104.709L104.187 65.4866C104.503 65.1383 105.069 64.9641 105.624 64.9641C107.006 64.9641 108.019 65.8459 108.019 67.3046C108.019 68.6326 106.995 69.7103 105.428 69.7103C103.926 69.7103 102.913 68.7306 102.815 67.6202ZM117.716 69.5361H116.66V63.5272L114.026 69.5361H113.046L110.434 63.5272V69.5361H109.378V61.8182H110.826L113.547 68.0992L116.29 61.8182H117.716V69.5361Z",
    fill: "#9097A3"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_12771_213521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204.101 99.8381H203.252V98.706C201.739 98.5536 200.999 97.5085 200.879 96.5506L201.913 96.224C201.979 96.9207 202.392 97.5956 203.252 97.748V95.4729L202.98 95.4185C201.87 95.1899 201.173 94.5041 201.173 93.4373C201.173 92.4031 202.033 91.5214 203.252 91.369V90.226H204.101V91.3799C205.44 91.5541 205.963 92.4467 206.137 93.1543L205.157 93.5135C205.092 93.0998 204.765 92.5338 204.101 92.3487V94.5803L204.265 94.6129C205.473 94.8524 206.202 95.658 206.202 96.6377C206.202 97.6065 205.484 98.5427 204.101 98.706V99.8381ZM205.136 96.6921C205.136 96.2349 204.809 95.8104 204.101 95.6471V97.748C204.809 97.6174 205.136 97.1929 205.136 96.6921ZM202.251 93.3937C202.251 93.8509 202.512 94.2428 203.252 94.3843V92.3161C202.621 92.4358 202.251 92.8603 202.251 93.3937ZM209.835 98.5645H208.79V93.5897H207.081V92.8386C208.061 92.8168 208.736 92.2725 208.899 91.5105H209.835V98.5645ZM212.3 95.0375C212.3 96.1152 212.496 96.8772 212.92 97.3235C213.193 97.6065 213.541 97.7807 214.042 97.7807C214.542 97.7807 214.891 97.6065 215.163 97.3235C215.587 96.8772 215.783 96.1152 215.783 95.0375C215.783 93.9598 215.587 93.1978 215.163 92.7515C214.891 92.4685 214.542 92.2943 214.042 92.2943C213.541 92.2943 213.193 92.4685 212.92 92.7515C212.496 93.1978 212.3 93.9598 212.3 95.0375ZM211.244 95.0375C211.244 94.0687 211.407 93.176 211.875 92.4793C212.333 91.7935 213.04 91.3472 214.042 91.3472C215.043 91.3472 215.751 91.7935 216.208 92.4793C216.676 93.176 216.839 94.0687 216.839 95.0375C216.839 96.0063 216.676 96.8989 216.208 97.5956C215.751 98.2814 215.043 98.7277 214.042 98.7277C213.04 98.7277 212.333 98.2814 211.875 97.5956C211.407 96.8989 211.244 96.0063 211.244 95.0375ZM226.705 98.5645H225.649V92.5555L223.014 98.5645H222.035L219.422 92.5555V98.5645H218.366V90.8465H219.814L222.535 97.1275L225.279 90.8465H226.705V98.5645ZM228.286 95.0048H230.322V92.8821H231.214V95.0048H233.261V95.8648H231.214V98.0093H230.322V95.8648H228.286V95.0048Z",
    fill: "#9097A3"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_12771_213521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.209 45.8093H135.36V44.6772C133.847 44.5248 133.106 43.4797 132.987 42.5218L134.021 42.1952C134.086 42.8919 134.5 43.5668 135.36 43.7192V41.4441L135.088 41.3897C133.977 41.1611 133.281 40.4753 133.281 39.4085C133.281 38.3743 134.141 37.4926 135.36 37.3402V36.1972H136.209V37.3511C137.548 37.5252 138.07 38.4179 138.244 39.1254L137.265 39.4847C137.199 39.071 136.873 38.505 136.209 38.3199V40.5515L136.372 40.5841C137.58 40.8236 138.31 41.6292 138.31 42.6089C138.31 43.5777 137.591 44.5139 136.209 44.6772V45.8093ZM137.243 42.6633C137.243 42.2061 136.916 41.7816 136.209 41.6183V43.7192C136.916 43.5886 137.243 43.164 137.243 42.6633ZM134.358 39.3649C134.358 39.8221 134.62 40.214 135.36 40.3555V38.2872C134.728 38.407 134.358 38.8315 134.358 39.3649ZM139.191 42.6198L140.214 42.315C140.28 43.1858 140.922 43.7736 141.804 43.7736C142.642 43.7736 143.317 43.2185 143.317 42.3476C143.317 41.3788 142.609 40.8889 141.793 40.8889C141.292 40.8889 140.813 41.0849 140.508 41.4006C140.138 41.259 139.822 41.1175 139.463 40.9869L140.378 37.4817H144.101V38.4614H141.085L140.563 40.4862C140.878 40.1378 141.444 39.9636 142 39.9636C143.382 39.9636 144.394 40.8454 144.394 42.3041C144.394 43.6321 143.371 44.7098 141.804 44.7098C140.301 44.7098 139.289 43.7301 139.191 42.6198ZM154.092 44.5356H153.036V38.5267L150.402 44.5356H149.422L146.809 38.5267V44.5356H145.754V36.8177H147.201L149.923 43.0987L152.666 36.8177H154.092V44.5356ZM158.515 41.8578H155.565V40.9651H158.515V41.8578ZM162.775 45.8093H161.926V44.6772C160.412 44.5248 159.672 43.4797 159.552 42.5218L160.587 42.1952C160.652 42.8919 161.066 43.5668 161.926 43.7192V41.4441L161.653 41.3897C160.543 41.1611 159.846 40.4753 159.846 39.4085C159.846 38.3743 160.706 37.4926 161.926 37.3402V36.1972H162.775V37.3511C164.114 37.5252 164.636 38.4179 164.81 39.1254L163.831 39.4847C163.765 39.071 163.439 38.505 162.775 38.3199V40.5515L162.938 40.5841C164.146 40.8236 164.876 41.6292 164.876 42.6089C164.876 43.5777 164.157 44.5139 162.775 44.6772V45.8093ZM163.809 42.6633C163.809 42.2061 163.482 41.7816 162.775 41.6183V43.7192C163.482 43.5886 163.809 43.164 163.809 42.6633ZM160.924 39.3649C160.924 39.8221 161.185 40.214 161.926 40.3555V38.2872C161.294 38.407 160.924 38.8315 160.924 39.3649ZM168.508 44.5356H167.463V39.5609H165.754V38.8098C166.734 38.788 167.409 38.2437 167.572 37.4817H168.508V44.5356ZM170.973 41.0087C170.973 42.0864 171.169 42.8484 171.594 43.2947C171.866 43.5777 172.214 43.7519 172.715 43.7519C173.216 43.7519 173.564 43.5777 173.836 43.2947C174.261 42.8484 174.457 42.0864 174.457 41.0087C174.457 39.931 174.261 39.169 173.836 38.7227C173.564 38.4396 173.216 38.2655 172.715 38.2655C172.214 38.2655 171.866 38.4396 171.594 38.7227C171.169 39.169 170.973 39.931 170.973 41.0087ZM169.917 41.0087C169.917 40.0398 170.081 39.1472 170.549 38.4505C171.006 37.7647 171.713 37.3184 172.715 37.3184C173.716 37.3184 174.424 37.7647 174.881 38.4505C175.349 39.1472 175.513 40.0398 175.513 41.0087C175.513 41.9775 175.349 42.8701 174.881 43.5668C174.424 44.2526 173.716 44.6989 172.715 44.6989C171.713 44.6989 171.006 44.2526 170.549 43.5668C170.081 42.8701 169.917 41.9775 169.917 41.0087ZM185.378 44.5356H184.322V38.5267L181.688 44.5356H180.708L178.095 38.5267V44.5356H177.039V36.8177H178.487L181.209 43.0987L183.952 36.8177H185.378V44.5356Z",
    fill: "#9097A3"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_12771_213521)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 182.5,
    cy: 56.5,
    r: 11.5,
    fill: "url(#paint8_linear_12771_213521)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_12771_213521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175 55.5002C175.264 55.0148 182.277 54.7938 184.5 56.0007C186.722 57.2075 188.814 63 188 64.5C187.736 64.9854 184.722 59.2074 182.5 58.0005C180.277 56.7937 170.501 55.5003 175 55.5002Z",
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_12771_213521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180.175 55.4313C180.336 55.1344 182.621 54.9064 183.855 55.5762C185.088 56.246 185.873 58.4893 185.712 58.7862C185.551 59.0831 184.485 57.1678 183.251 56.498C182.018 55.8282 180.014 55.7281 180.175 55.4313Z",
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_12771_213521)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 240.5,
    cy: 109.5,
    r: 11.5,
    fill: "url(#paint9_linear_12771_213521)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_f_12771_213521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233 108.5C233.264 108.015 240.277 107.794 242.5 109.001C244.722 110.208 246.814 116 246 117.5C245.736 117.985 242.722 112.207 240.5 111.001C238.277 109.794 228.501 108.5 233 108.5Z",
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_f_12771_213521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238.175 108.431C238.336 108.134 240.621 107.906 241.855 108.576C243.088 109.246 243.873 111.489 243.712 111.786C243.551 112.083 242.485 110.168 241.251 109.498C240.018 108.828 238.014 108.728 238.175 108.431Z",
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_f_12771_213521)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 65.5,
    cy: 109.5,
    r: 11.5,
    fill: "url(#paint10_linear_12771_213521)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_f_12771_213521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.0001 108.5C58.2636 108.015 65.2769 107.794 67.4997 109.001C69.7224 110.208 71.8144 116 71 117.5C70.7365 117.985 67.7224 112.207 65.4997 111.001C63.277 109.794 53.5009 108.5 58.0001 108.5Z",
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_f_12771_213521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.1752 108.431C63.3364 108.134 65.6212 107.906 66.8548 108.576C68.0884 109.246 68.8729 111.489 68.7117 111.786C68.5506 112.083 67.485 110.168 66.2515 109.498C65.0179 108.828 63.014 108.728 63.1752 108.431Z",
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_f_12771_213521)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 125.5,
    cy: 81.5,
    r: 11.5,
    fill: "url(#paint11_linear_12771_213521)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_f_12771_213521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118 80.5002C118.264 80.0148 125.277 79.7938 127.5 81.0007C129.722 82.2075 131.814 88 131 89.5C130.736 89.9854 127.722 84.2074 125.5 83.0005C123.277 81.7937 113.501 80.5003 118 80.5002Z",
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_f_12771_213521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.175 80.4313C123.336 80.1344 125.621 79.9064 126.855 80.5762C128.088 81.246 128.873 83.4893 128.712 83.7862C128.551 84.0831 127.485 82.1678 126.251 81.498C125.018 80.8282 123.014 80.7281 123.175 80.4313Z",
    fill: "#D9D9D9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bd_12771_213521",
    x: 189.187,
    y: 105.187,
    width: 58.6255,
    height: 58.0273,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.40638
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_12771_213521"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.60729
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.803644
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_12771_213521",
    result: "effect2_dropShadow_12771_213521"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_12771_213521",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_12771_213521",
    x: 18.9072,
    y: 80.3076,
    width: 48.8857,
    height: 23.0713,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.64101
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_12771_213521"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_12771_213521",
    x: 66.0781,
    y: 54.0005,
    width: 58.8857,
    height: 23.0713,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.64101
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_12771_213521"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_12771_213521",
    x: 194.893,
    y: 83.0288,
    width: 44.8857,
    height: 23.0713,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.64101
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_12771_213521"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_12771_213521",
    x: 127,
    y: 29,
    width: 64.8857,
    height: 23.0713,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.64101
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_12771_213521"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_12771_213521",
    x: 141,
    y: 15,
    width: 83,
    height: 83,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15,
    result: "effect1_foregroundBlur_12771_213521"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_12771_213521",
    x: 167.83,
    y: 49.1113,
    width: 26.3496,
    height: 21.4175,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_12771_213521"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_12771_213521",
    x: 178.166,
    y: 53.1406,
    width: 9.56641,
    height: 7.67676,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_12771_213521"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_12771_213521",
    x: 199,
    y: 68,
    width: 83,
    height: 83,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15,
    result: "effect1_foregroundBlur_12771_213521"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_12771_213521",
    x: 225.83,
    y: 102.111,
    width: 26.3496,
    height: 21.4175,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_12771_213521"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_12771_213521",
    x: 236.166,
    y: 106.141,
    width: 9.56641,
    height: 7.67676,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_12771_213521"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_f_12771_213521",
    x: 24,
    y: 68,
    width: 83,
    height: 83,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15,
    result: "effect1_foregroundBlur_12771_213521"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_f_12771_213521",
    x: 50.8301,
    y: 102.111,
    width: 26.3496,
    height: 21.4175,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_12771_213521"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_f_12771_213521",
    x: 61.166,
    y: 106.141,
    width: 9.56641,
    height: 7.67676,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_12771_213521"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_f_12771_213521",
    x: 84,
    y: 40,
    width: 83,
    height: 83,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15,
    result: "effect1_foregroundBlur_12771_213521"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_f_12771_213521",
    x: 110.83,
    y: 74.1113,
    width: 26.3496,
    height: 21.4175,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_12771_213521"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_f_12771_213521",
    x: 121.166,
    y: 78.1406,
    width: 9.56641,
    height: 7.67676,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_12771_213521"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12771_213521",
    x1: 82.3541,
    y1: 176.923,
    x2: 98.7968,
    y2: 146.315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12771_213521",
    x1: 22.0769,
    y1: 157.537,
    x2: 75.1756,
    y2: 149.239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12771_213521",
    x1: 140.354,
    y1: 186.361,
    x2: 170.592,
    y2: 150.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_12771_213521",
    x1: 80.0769,
    y1: 156.163,
    x2: 133.93,
    y2: 150.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_12771_213521",
    x1: 198.354,
    y1: 194.497,
    x2: 238.389,
    y2: 157.937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_12771_213521",
    x1: 138.077,
    y1: 154.979,
    x2: 192.155,
    y2: 150.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_12771_213521",
    x1: 256.354,
    y1: 176.923,
    x2: 272.797,
    y2: 146.315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_12771_213521",
    x1: 196.077,
    y1: 157.537,
    x2: 251.342,
    y2: 147.685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_12771_213521",
    x1: 183,
    y1: 56.5,
    x2: 182.5,
    y2: 77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_12771_213521",
    x1: 241,
    y1: 109.5,
    x2: 240.5,
    y2: 130,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_12771_213521",
    x1: 66,
    y1: 109.5,
    x2: 65.5,
    y2: 130,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_12771_213521",
    x1: 126,
    y1: 81.5,
    x2: 125.5,
    y2: 102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12771_213521"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 263,
    height: 185,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunity);
export default __webpack_public_path__ + "static/media/community.649e21fa68d25eea900b913278ee8939.svg";
export { ForwardRef as ReactComponent };